const UND_ORDEM = ["kg", "gr", "un", "unid", "lata", "pct", "ml", "l"];

export function rotuloUnd(und?: string | null): string {
  const txt = (und ?? "").trim();
  return txt || "sem unidade";
}

export function compararUndNome(a: string, b: string): number {
  const ia = UND_ORDEM.indexOf(a.toLowerCase());
  const ib = UND_ORDEM.indexOf(b.toLowerCase());
  if (ia >= 0 && ib >= 0) return ia - ib;
  if (ia >= 0) return -1;
  if (ib >= 0) return 1;
  return a.localeCompare(b, "pt-BR");
}

export function groupByUndNome<T>(
  items: T[],
  getUnd: (item: T) => string | null | undefined
): Array<{ undNome: string; items: T[] }> {
  const map = new Map<string, T[]>();
  for (const item of items) {
    const und = rotuloUnd(getUnd(item));
    const lista = map.get(und);
    if (lista) lista.push(item);
    else map.set(und, [item]);
  }
  return Array.from(map.entries())
    .map(([undNome, grouped]) => ({ undNome, items: grouped }))
    .sort((a, b) => compararUndNome(a.undNome, b.undNome));
}
